import { MainMenuItemType } from 'constants/top-bar-constants';

const ALIAS = {
    MIN_LENGTH: 2,
    MAX_LENGTH: 50,
};

const ALIAS_STATUS = {
    ALIAS_ONLY: 1,
    NAME_AND_ALIAS: 2,
};

const USER_CUSTOM_STATUS = {
    MAX_LENGTH: 100,
};

const OPERATIONAL_STATUS_OFF = 0;

const AVAILABILITY = {
    ON_DUTY: 0,
    OFF_DUTY: 1,
};

const CONNECTIVITY = {
    CONNECTED: 1,
    DISCONNECTED: 0,
};

const PROFILE_IMAGE_MAX_SIZE = 15;

const GLOBAL_ACTIVE_INACTIVE = {
    INACTIVE: 0,
    ACTIVE: 1,
};

const DISTANCE_UNIT = {
    YARD: 'yard',
    METER: 'meter',
};

const MY_BUSINESS_OPTIONS = {
    TABS: {
        ACTIVITY: 'activity',
        START: 'processes',
    },
    CONFIRMATION_WINDOW_DISPLAY: {
        TAKE_LEAD: 'mybusiness-take-lead',
        UNTAKE_LEAD: 'mybusiness-untake-lead',
        CANCEL_PROCESS: 'mybusiness-cancel-process',
        CANCEL_REPEAT_PROCESS: 'mybusiness-cancel-repeat-process',
        COMPLETE_PROCESS: 'mybusiness-complete-process',
    },
};

const USER_SETTINGS_OPTIONS = {
    PAGES: {
        CONTACTS: MainMenuItemType.CONTACTS,
        CONVERSATIONS: MainMenuItemType.CONVERSATIONS,
        CHANNELS: MainMenuItemType.CHANNELS,
        GEOLOCATION: MainMenuItemType.GEOLOCATION,
        MY_BUSINESS: MainMenuItemType.MY_BUSINESS,
    },
    ACTIONS: {
        MESSAGE: 'message',
        CALL: 'call',
        PTT: 'ptt',
    },
    SEND_BUTTONS: {
        SEND: 'send',
        OK_SEND: 'oksend',
    },
    CONTACTS_PAGE_TABS: {
        USERS: 'users',
        GROUPS: 'groups',
    },
    PTT_TAKE_FLOOR_MODE: {
        PTT_MODE: 0,
        TOGGLE: 1,
        BOTH: 2,
    },
    CHANNELS_PLAYBACK_MODE: {
        HEAR_ALL: 0,
        HEAR_FIRST_SPEAKER: 1,
        HEAR_FIRST_PRIORITY: 2,
    },
    CHANNELS_CONFIRMATION_WINDOW_DISPLAY: {
        JOIN_CHANNEL: 'channel-join',
        LEAVE_CHANNEL: 'channel-leave',
        EXIT_CALL_FORWARD: 'call-forward-exit',
        OVERRIDE_CALL_FORWARD: 'call-forward-override',
    },
    CHANNELS_ADVANCED_MODE: {
        STANDARD: 0,
        ADVANCED: 1,
    },
    SORT_CONTACTS_BY: {
        FIRST_NAME: 'FN',
        LAST_NAME: 'LN',
    },
};

export {
    ALIAS,
    ALIAS_STATUS,
    USER_CUSTOM_STATUS,
    OPERATIONAL_STATUS_OFF,
    AVAILABILITY,
    CONNECTIVITY,
    USER_SETTINGS_OPTIONS,
    GLOBAL_ACTIVE_INACTIVE,
    DISTANCE_UNIT,
    PROFILE_IMAGE_MAX_SIZE,
    MY_BUSINESS_OPTIONS,
};
